import { Center, Spinner } from "@chakra-ui/react"
import { type ReactNode, Suspense } from "react"

type LazyRoutePageProps = {
  children: ReactNode
}

export default function LazyRoutePage({ children }: LazyRoutePageProps) {
  return (
    <Suspense
      fallback={
        <Center minH="40vh">
          <Spinner size="xl" color="main.accent" />
        </Center>
      }
    >
      {children}
    </Suspense>
  )
}
